import React from "react";

const DocumentIcon = ({ size = { width: 14, height: 16 }, className }) => {
  return (
    <svg
      width={size.width}
      height={size.height}
      viewBox="0 0 13 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className} // Tailwind color control ke liye
    >
      <mask id="path-1-inside-1" fill="white">
        <path d="M12.1113 14.8818H0V4.52148L4.52148 0H12.1113V14.8818Z" />
      </mask>
      <path
        d="M12.1113 14.8818V15.8818H13.1113V14.8818H12.1113ZM0 14.8818H-1V15.8818H0V14.8818ZM0 4.52148L-0.707107 3.81438L-1 4.10727V4.52148H0ZM4.52148 0V-1H4.10727L3.81438 -0.707107L4.52148 0ZM12.1113 0H13.1113V-1H12.1113V0ZM12.1113 14.8818V13.8818H0V14.8818V15.8818H12.1113V14.8818ZM0 14.8818H1V4.52148H0H-1V14.8818H0ZM0 4.52148L0.707107 5.22859L5.22859 0.707107L4.52148 0L3.81438 -0.707107L-0.707107 3.81438L0 4.52148ZM4.52148 0V1H12.1113V0V-1H4.52148V0ZM12.1113 0H11.1113V14.8818H12.1113H13.1113V0H12.1113Z"
        fill="currentColor" // <- currentColor use kiya
        mask="url(#path-1-inside-1)"
      />
      <path d="M0.63623 4.71258H5.04834V0.668213" stroke="currentColor" />
      <path d="M2.78906 8.39014H9.32324" stroke="currentColor" />
      <path d="M2.78906 10.1868H9.32324" stroke="currentColor" />
      <path d="M2.78906 11.9834H9.32324" stroke="currentColor" />
    </svg>
  );
};

export default DocumentIcon;
